import React from 'react';
import { useParams } from 'react-router-dom';
import ExpedienteFormWizard from './expediente-form/ExpedienteFormWizard';

const ExpedienteEditForm = () => {
  const { id } = useParams();
  return <ExpedienteFormWizard mode="edit" expedienteId={id} />;
};

export default ExpedienteEditForm;
